import React from 'react'
import { Textarea } from 'app/theme/forms'

export default function LeadComment(props) {
  const {
    data,
    setData,
    setErrors,
    errors,
    inputPlaceholder = 'Additional questions/comments',
  } = props

  return (
    <div>
      <div className="p-8 pb-10">
        <div className="grid gap-6 m-auto lg:w-2/3">
          <Textarea
            autoFocus
            data-test-id="comment"
            value={data.comment}
            error={errors?.comment}
            placeholder={inputPlaceholder}
            rows={4}
            onChange={comment => {
              setErrors(prev => ({
                ...prev,
                comment: null,
              }))
              setData(prev => ({
                ...prev,
                comment,
              }))
            }}
          />
        </div>
      </div>
    </div>
  )
}
